import React, { Component } from "react";
import PropTypes from "prop-types";
import { createStarterCampaign } from "../../actions/index";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import AdminStarterCampaignsForm from "./AdminStarterCampaignsForm";
import * as Constants from '../../constants';

class AdminStarterCampaignsNew extends Component {
  static propTypes = {
    createStarterCampaign: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired
  };

  onSubmit(props) {
    this.props
      .createStarterCampaign(props)
      .then(campaign => {
        if (campaign.payload != undefined) {
          toastr.success("Starter Workflow created!");
          this.props.history.push(`/campaigns/${campaign.payload.data.data.id}`);
        }
      });
  }

  render() {
    return (
      <div>
        <h1>Add New Starter Workflow</h1>
        <AdminStarterCampaignsForm
          match={this.props.match}
          handleSubmit={this.onSubmit.bind(this)}
          mode="new"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { createStarterCampaign }
)(AdminStarterCampaignsNew);
